import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Icon
} from "antd";

const intl = {
  data: {
    en:
      "We care about your data please select a password so you can access your results and always come back to view it again",
    dk:
      "Vi tager os af din data så venligst vælg et password så du kan tilgå dine resultater og altid vende tilbage igen"
  },
  account: {
    en: "Already have an account?",
    dk: "Har du allerede en konto?"
  },
  setupAccount: {
    en: "SETUP ACCOUNT",
    dk: "OPRET KONTO"
  },
  policies: {
    en: "By signing up you agree to Terms and Conditions",
    dk: "Ved at oprette dig accepterer du vores Terms and Conditions"
  }
};

function SignUpForm(props) {
  return (
    <div>
      <iframe
        title='sign-up-form'
        style={{ visibility: "hidden" }}
        width="0"
        height="0"
        border="0"
        name="targetFrame"
        id="targetFrame"
      />
      <form
        target="targetFrame"
        onSubmit={e => {
          e.preventDefault();

          // Creates the user with the data.
          props.addAccount(
            props.email,
            props.password,
            props.name,
            props.age,
            props.education,
            props.experience,
            props.references
          );
        }}
      >
        <Row className="survey_content_container">
          <Col md={{ span: 12, offset: 6 }} xs={24}>
            <Row gutter={16}>
              <Col md={24} style={{ marginBottom: "20px" }}>
                <h1 style={{ color: "#1abc9c" }}>
                  {intl.data[props.language]}
                </h1>
              </Col>
              <Col md={24} style={{ marginBottom: "20px", textAlign: "right" }}>
                <div
                  role="presentation"
                  onClick={() =>
                    props.updateEvaluation({ step: "SIGNIN_EVALUATION" })
                  }
                  style={{
                    color: "#fff",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                >
                  {intl.account[props.language]}
                </div>
              </Col>
              <Col md={24} style={{ marginBottom: "20px" }}>
                <Input
                  type="email"
                  name="email"
                  size="large"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  value={props.email}
                  placeholder="E-MAIL"
                  onChange={e =>
                    props.updateEvaluation({ email: e.target.value })
                  }
                  style={{ textAlign: "center", color: "#1abc9c" }}
                  required
                />
              </Col>
              <Col md={24} style={{ marginBottom: "20px" }}>
                <Input
                  name="password"
                  type="password"
                  placeholder="PASSWORD"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  value={props.password}
                  style={{ textAlign: "center", color: "#1abc9c" }}
                  size="large"
                  onChange={e =>
                    props.updateEvaluation({ password: e.target.value })
                  }
                  required
                />
              </Col>
            </Row>
          </Col>
          <Col md={{ span: 16, offset: 4 }} xs={24}>
            <Button
              htmlType="submit"
              type="primary"
              size="large"
              style={{ padding: "0 30px" }}
              loading={props.submitting}
            >
              {intl.setupAccount[props.language]}
            </Button>
            <div>{intl.policies[props.language]}</div>
            {props.errorMessage && (
              <span style={{ color: "red" }}>{props.errorMessage}</span>
            )}
          </Col>
        </Row>
      </form>
    </div>
  );
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/pages/Evaluation/SignUpForm.js